
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("eE7hg"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("222yI"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("aNBLQ"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("fEa9b"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("8mZXO"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lXCcg"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("8vDFm"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9oUXz"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("tFQTd"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("aOasM"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("a0YkE"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("9kPhy"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("eE7hg", function(module, exports) {

let $aa9a724081fa7d3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa9a724081fa7d3a$var$load("2YffH"),
    $aa9a724081fa7d3a$var$load("1o23t"),
    $aa9a724081fa7d3a$var$load("lqFMg"),
    $aa9a724081fa7d3a$var$load("duC9l"),
    $aa9a724081fa7d3a$var$load("ci4aH"),
    $aa9a724081fa7d3a$var$load("l1nJ9"),
    $aa9a724081fa7d3a$var$load("iQ0Jm"),
    $aa9a724081fa7d3a$var$load("eBRUf"),
    $aa9a724081fa7d3a$var$load("9Vh0G"),
    $aa9a724081fa7d3a$var$load("hBIgN"),
    $aa9a724081fa7d3a$var$load("h4Nf7"),
    $aa9a724081fa7d3a$var$load("7f9Fz"),
    $aa9a724081fa7d3a$var$load("8YSo7"),
    $aa9a724081fa7d3a$var$load("eYWAR"),
    $aa9a724081fa7d3a$var$load("8z2kq"),
    $aa9a724081fa7d3a$var$load("g9CVe"),
    $aa9a724081fa7d3a$var$load("djHM5"),
    $aa9a724081fa7d3a$var$load("eJQji"),
    $aa9a724081fa7d3a$var$load("6wr18"),
    $aa9a724081fa7d3a$var$load("kjZZD"),
    $aa9a724081fa7d3a$var$load("3JSgG"),
    $aa9a724081fa7d3a$var$load("dRpV3"),
    $aa9a724081fa7d3a$var$load("ffEVr"),
    $aa9a724081fa7d3a$var$load("28arV"),
    $aa9a724081fa7d3a$var$load("jYUNl"),
    $aa9a724081fa7d3a$var$load("foy8I"),
    $aa9a724081fa7d3a$var$load("jY21r"),
    $aa9a724081fa7d3a$var$load("2vAWg"),
    $aa9a724081fa7d3a$var$load("7cABH"),
    $aa9a724081fa7d3a$var$load("9jjvO"),
    $aa9a724081fa7d3a$var$load("i8eeg"),
    $aa9a724081fa7d3a$var$load("iFdoJ"),
    $aa9a724081fa7d3a$var$load("2uVTT"),
    $aa9a724081fa7d3a$var$load("hhss7"),
    $aa9a724081fa7d3a$var$load("Wowvf"),
    $aa9a724081fa7d3a$var$load("4Nzvy"),
    $aa9a724081fa7d3a$var$load("hJpvQ"),
    $aa9a724081fa7d3a$var$load("bIPPg"),
    $aa9a724081fa7d3a$var$load("lnKog"),
    $aa9a724081fa7d3a$var$load("h3ABO"),
    $aa9a724081fa7d3a$var$load("kC80R"),
    $aa9a724081fa7d3a$var$load("7EorR"),
    $aa9a724081fa7d3a$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("222yI", function(module, exports) {

let $17adc0d438a31ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17adc0d438a31ef8$var$load("2YffH"),
    $17adc0d438a31ef8$var$load("1o23t"),
    $17adc0d438a31ef8$var$load("lqFMg"),
    $17adc0d438a31ef8$var$load("duC9l"),
    $17adc0d438a31ef8$var$load("ci4aH"),
    $17adc0d438a31ef8$var$load("l1nJ9"),
    $17adc0d438a31ef8$var$load("iQ0Jm"),
    $17adc0d438a31ef8$var$load("eBRUf"),
    $17adc0d438a31ef8$var$load("9Vh0G"),
    $17adc0d438a31ef8$var$load("hBIgN"),
    $17adc0d438a31ef8$var$load("h4Nf7"),
    $17adc0d438a31ef8$var$load("7f9Fz"),
    $17adc0d438a31ef8$var$load("8YSo7"),
    $17adc0d438a31ef8$var$load("eYWAR"),
    $17adc0d438a31ef8$var$load("8z2kq"),
    $17adc0d438a31ef8$var$load("g9CVe"),
    $17adc0d438a31ef8$var$load("djHM5"),
    $17adc0d438a31ef8$var$load("eJQji"),
    $17adc0d438a31ef8$var$load("6wr18"),
    $17adc0d438a31ef8$var$load("kjZZD"),
    $17adc0d438a31ef8$var$load("3JSgG"),
    $17adc0d438a31ef8$var$load("dRpV3"),
    $17adc0d438a31ef8$var$load("ffEVr"),
    $17adc0d438a31ef8$var$load("28arV"),
    $17adc0d438a31ef8$var$load("jYUNl"),
    $17adc0d438a31ef8$var$load("foy8I"),
    $17adc0d438a31ef8$var$load("jY21r"),
    $17adc0d438a31ef8$var$load("2vAWg"),
    $17adc0d438a31ef8$var$load("7cABH"),
    $17adc0d438a31ef8$var$load("9jjvO"),
    $17adc0d438a31ef8$var$load("i8eeg"),
    $17adc0d438a31ef8$var$load("iFdoJ"),
    $17adc0d438a31ef8$var$load("2uVTT"),
    $17adc0d438a31ef8$var$load("hhss7"),
    $17adc0d438a31ef8$var$load("Wowvf"),
    $17adc0d438a31ef8$var$load("4Nzvy"),
    $17adc0d438a31ef8$var$load("hJpvQ"),
    $17adc0d438a31ef8$var$load("bIPPg"),
    $17adc0d438a31ef8$var$load("lnKog"),
    $17adc0d438a31ef8$var$load("h3ABO"),
    $17adc0d438a31ef8$var$load("kC80R"),
    $17adc0d438a31ef8$var$load("7EorR"),
    $17adc0d438a31ef8$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("aNBLQ", function(module, exports) {

let $7dcbc77a89f1b0f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7dcbc77a89f1b0f5$var$load("2YffH"),
    $7dcbc77a89f1b0f5$var$load("1o23t"),
    $7dcbc77a89f1b0f5$var$load("lqFMg"),
    $7dcbc77a89f1b0f5$var$load("duC9l"),
    $7dcbc77a89f1b0f5$var$load("ci4aH"),
    $7dcbc77a89f1b0f5$var$load("l1nJ9"),
    $7dcbc77a89f1b0f5$var$load("iQ0Jm"),
    $7dcbc77a89f1b0f5$var$load("eBRUf"),
    $7dcbc77a89f1b0f5$var$load("9Vh0G"),
    $7dcbc77a89f1b0f5$var$load("hBIgN"),
    $7dcbc77a89f1b0f5$var$load("h4Nf7"),
    $7dcbc77a89f1b0f5$var$load("7f9Fz"),
    $7dcbc77a89f1b0f5$var$load("8YSo7"),
    $7dcbc77a89f1b0f5$var$load("eYWAR"),
    $7dcbc77a89f1b0f5$var$load("8z2kq"),
    $7dcbc77a89f1b0f5$var$load("g9CVe"),
    $7dcbc77a89f1b0f5$var$load("djHM5"),
    $7dcbc77a89f1b0f5$var$load("eJQji"),
    $7dcbc77a89f1b0f5$var$load("6wr18"),
    $7dcbc77a89f1b0f5$var$load("kjZZD"),
    $7dcbc77a89f1b0f5$var$load("3JSgG"),
    $7dcbc77a89f1b0f5$var$load("dRpV3"),
    $7dcbc77a89f1b0f5$var$load("ffEVr"),
    $7dcbc77a89f1b0f5$var$load("28arV"),
    $7dcbc77a89f1b0f5$var$load("jYUNl"),
    $7dcbc77a89f1b0f5$var$load("foy8I"),
    $7dcbc77a89f1b0f5$var$load("jY21r"),
    $7dcbc77a89f1b0f5$var$load("2vAWg"),
    $7dcbc77a89f1b0f5$var$load("7cABH"),
    $7dcbc77a89f1b0f5$var$load("9jjvO"),
    $7dcbc77a89f1b0f5$var$load("i8eeg"),
    $7dcbc77a89f1b0f5$var$load("iFdoJ"),
    $7dcbc77a89f1b0f5$var$load("2uVTT"),
    $7dcbc77a89f1b0f5$var$load("hhss7"),
    $7dcbc77a89f1b0f5$var$load("Wowvf"),
    $7dcbc77a89f1b0f5$var$load("4Nzvy"),
    $7dcbc77a89f1b0f5$var$load("hJpvQ"),
    $7dcbc77a89f1b0f5$var$load("bIPPg"),
    $7dcbc77a89f1b0f5$var$load("lnKog"),
    $7dcbc77a89f1b0f5$var$load("h3ABO"),
    $7dcbc77a89f1b0f5$var$load("kC80R"),
    $7dcbc77a89f1b0f5$var$load("7EorR"),
    $7dcbc77a89f1b0f5$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("fEa9b", function(module, exports) {

let $b64276777f503225$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b64276777f503225$var$load("eYWAR"),
    $b64276777f503225$var$load("8z2kq"),
    $b64276777f503225$var$load("2YffH"),
    $b64276777f503225$var$load("lqFMg"),
    $b64276777f503225$var$load("duC9l"),
    $b64276777f503225$var$load("ci4aH"),
    $b64276777f503225$var$load("hJpvQ"),
    $b64276777f503225$var$load("l1nJ9"),
    $b64276777f503225$var$load("eBRUf"),
    $b64276777f503225$var$load("9Vh0G"),
    $b64276777f503225$var$load("hBIgN"),
    $b64276777f503225$var$load("h4Nf7"),
    $b64276777f503225$var$load("7f9Fz"),
    $b64276777f503225$var$load("8YSo7"),
    $b64276777f503225$var$load("g9CVe"),
    $b64276777f503225$var$load("djHM5"),
    $b64276777f503225$var$load("eJQji"),
    $b64276777f503225$var$load("6wr18"),
    $b64276777f503225$var$load("kjZZD"),
    $b64276777f503225$var$load("3JSgG"),
    $b64276777f503225$var$load("dRpV3"),
    $b64276777f503225$var$load("ffEVr"),
    $b64276777f503225$var$load("28arV"),
    $b64276777f503225$var$load("jYUNl"),
    $b64276777f503225$var$load("foy8I"),
    $b64276777f503225$var$load("jY21r"),
    $b64276777f503225$var$load("2vAWg"),
    $b64276777f503225$var$load("7cABH"),
    $b64276777f503225$var$load("9jjvO"),
    $b64276777f503225$var$load("i8eeg"),
    $b64276777f503225$var$load("iFdoJ"),
    $b64276777f503225$var$load("bIPPg"),
    $b64276777f503225$var$load("2uVTT"),
    $b64276777f503225$var$load("hhss7"),
    $b64276777f503225$var$load("Wowvf"),
    $b64276777f503225$var$load("4Nzvy"),
    $b64276777f503225$var$load("h3ABO"),
    $b64276777f503225$var$load("kC80R"),
    $b64276777f503225$var$load("7EorR"),
    $b64276777f503225$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("8mZXO", function(module, exports) {

let $6180717c1c916466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6180717c1c916466$var$load("eYWAR"),
    $6180717c1c916466$var$load("8z2kq"),
    $6180717c1c916466$var$load("2YffH"),
    $6180717c1c916466$var$load("lqFMg"),
    $6180717c1c916466$var$load("duC9l"),
    $6180717c1c916466$var$load("ci4aH"),
    $6180717c1c916466$var$load("hJpvQ"),
    $6180717c1c916466$var$load("l1nJ9"),
    $6180717c1c916466$var$load("eBRUf"),
    $6180717c1c916466$var$load("9Vh0G"),
    $6180717c1c916466$var$load("hBIgN"),
    $6180717c1c916466$var$load("h4Nf7"),
    $6180717c1c916466$var$load("7f9Fz"),
    $6180717c1c916466$var$load("8YSo7"),
    $6180717c1c916466$var$load("g9CVe"),
    $6180717c1c916466$var$load("djHM5"),
    $6180717c1c916466$var$load("eJQji"),
    $6180717c1c916466$var$load("6wr18"),
    $6180717c1c916466$var$load("kjZZD"),
    $6180717c1c916466$var$load("3JSgG"),
    $6180717c1c916466$var$load("dRpV3"),
    $6180717c1c916466$var$load("ffEVr"),
    $6180717c1c916466$var$load("28arV"),
    $6180717c1c916466$var$load("jYUNl"),
    $6180717c1c916466$var$load("foy8I"),
    $6180717c1c916466$var$load("jY21r"),
    $6180717c1c916466$var$load("2vAWg"),
    $6180717c1c916466$var$load("7cABH"),
    $6180717c1c916466$var$load("9jjvO"),
    $6180717c1c916466$var$load("i8eeg"),
    $6180717c1c916466$var$load("iFdoJ"),
    $6180717c1c916466$var$load("bIPPg"),
    $6180717c1c916466$var$load("2uVTT"),
    $6180717c1c916466$var$load("hhss7"),
    $6180717c1c916466$var$load("Wowvf"),
    $6180717c1c916466$var$load("4Nzvy"),
    $6180717c1c916466$var$load("h3ABO"),
    $6180717c1c916466$var$load("kC80R"),
    $6180717c1c916466$var$load("7EorR"),
    $6180717c1c916466$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("lXCcg", function(module, exports) {

let $ffccbcc6476f6620$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffccbcc6476f6620$var$load("eYWAR"),
    $ffccbcc6476f6620$var$load("8z2kq"),
    $ffccbcc6476f6620$var$load("2YffH"),
    $ffccbcc6476f6620$var$load("lqFMg"),
    $ffccbcc6476f6620$var$load("duC9l"),
    $ffccbcc6476f6620$var$load("ci4aH"),
    $ffccbcc6476f6620$var$load("hJpvQ"),
    $ffccbcc6476f6620$var$load("l1nJ9"),
    $ffccbcc6476f6620$var$load("eBRUf"),
    $ffccbcc6476f6620$var$load("9Vh0G"),
    $ffccbcc6476f6620$var$load("hBIgN"),
    $ffccbcc6476f6620$var$load("h4Nf7"),
    $ffccbcc6476f6620$var$load("7f9Fz"),
    $ffccbcc6476f6620$var$load("8YSo7"),
    $ffccbcc6476f6620$var$load("g9CVe"),
    $ffccbcc6476f6620$var$load("djHM5"),
    $ffccbcc6476f6620$var$load("eJQji"),
    $ffccbcc6476f6620$var$load("6wr18"),
    $ffccbcc6476f6620$var$load("kjZZD"),
    $ffccbcc6476f6620$var$load("3JSgG"),
    $ffccbcc6476f6620$var$load("dRpV3"),
    $ffccbcc6476f6620$var$load("ffEVr"),
    $ffccbcc6476f6620$var$load("28arV"),
    $ffccbcc6476f6620$var$load("jYUNl"),
    $ffccbcc6476f6620$var$load("foy8I"),
    $ffccbcc6476f6620$var$load("jY21r"),
    $ffccbcc6476f6620$var$load("2vAWg"),
    $ffccbcc6476f6620$var$load("7cABH"),
    $ffccbcc6476f6620$var$load("9jjvO"),
    $ffccbcc6476f6620$var$load("i8eeg"),
    $ffccbcc6476f6620$var$load("iFdoJ"),
    $ffccbcc6476f6620$var$load("bIPPg"),
    $ffccbcc6476f6620$var$load("2uVTT"),
    $ffccbcc6476f6620$var$load("hhss7"),
    $ffccbcc6476f6620$var$load("Wowvf"),
    $ffccbcc6476f6620$var$load("4Nzvy"),
    $ffccbcc6476f6620$var$load("h3ABO"),
    $ffccbcc6476f6620$var$load("kC80R"),
    $ffccbcc6476f6620$var$load("7EorR"),
    $ffccbcc6476f6620$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("8vDFm", function(module, exports) {

let $631ffcd4bac70a63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $631ffcd4bac70a63$var$load("eYWAR"),
    $631ffcd4bac70a63$var$load("8z2kq"),
    $631ffcd4bac70a63$var$load("2YffH"),
    $631ffcd4bac70a63$var$load("lqFMg"),
    $631ffcd4bac70a63$var$load("duC9l"),
    $631ffcd4bac70a63$var$load("ci4aH"),
    $631ffcd4bac70a63$var$load("l1nJ9"),
    $631ffcd4bac70a63$var$load("eBRUf"),
    $631ffcd4bac70a63$var$load("9Vh0G"),
    $631ffcd4bac70a63$var$load("hBIgN"),
    $631ffcd4bac70a63$var$load("h4Nf7"),
    $631ffcd4bac70a63$var$load("7f9Fz"),
    $631ffcd4bac70a63$var$load("8YSo7"),
    $631ffcd4bac70a63$var$load("g9CVe"),
    $631ffcd4bac70a63$var$load("djHM5"),
    $631ffcd4bac70a63$var$load("eJQji"),
    $631ffcd4bac70a63$var$load("6wr18"),
    $631ffcd4bac70a63$var$load("kjZZD"),
    $631ffcd4bac70a63$var$load("3JSgG"),
    $631ffcd4bac70a63$var$load("dRpV3"),
    $631ffcd4bac70a63$var$load("ffEVr"),
    $631ffcd4bac70a63$var$load("28arV"),
    $631ffcd4bac70a63$var$load("jYUNl"),
    $631ffcd4bac70a63$var$load("foy8I"),
    $631ffcd4bac70a63$var$load("jY21r"),
    $631ffcd4bac70a63$var$load("2vAWg"),
    $631ffcd4bac70a63$var$load("7cABH"),
    $631ffcd4bac70a63$var$load("9jjvO"),
    $631ffcd4bac70a63$var$load("i8eeg"),
    $631ffcd4bac70a63$var$load("iFdoJ"),
    $631ffcd4bac70a63$var$load("2uVTT"),
    $631ffcd4bac70a63$var$load("hhss7"),
    $631ffcd4bac70a63$var$load("Wowvf"),
    $631ffcd4bac70a63$var$load("4Nzvy"),
    $631ffcd4bac70a63$var$load("hJpvQ"),
    $631ffcd4bac70a63$var$load("bIPPg"),
    $631ffcd4bac70a63$var$load("lnKog"),
    $631ffcd4bac70a63$var$load("h3ABO"),
    $631ffcd4bac70a63$var$load("kC80R"),
    $631ffcd4bac70a63$var$load("7EorR"),
    $631ffcd4bac70a63$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("9oUXz", function(module, exports) {

let $6d8289f957f3fe9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d8289f957f3fe9d$var$load("2YffH"),
    $6d8289f957f3fe9d$var$load("lqFMg"),
    $6d8289f957f3fe9d$var$load("duC9l"),
    $6d8289f957f3fe9d$var$load("ci4aH"),
    $6d8289f957f3fe9d$var$load("l1nJ9"),
    $6d8289f957f3fe9d$var$load("eBRUf"),
    $6d8289f957f3fe9d$var$load("9Vh0G"),
    $6d8289f957f3fe9d$var$load("hBIgN"),
    $6d8289f957f3fe9d$var$load("h4Nf7"),
    $6d8289f957f3fe9d$var$load("7f9Fz"),
    $6d8289f957f3fe9d$var$load("8YSo7"),
    $6d8289f957f3fe9d$var$load("eYWAR"),
    $6d8289f957f3fe9d$var$load("8z2kq"),
    $6d8289f957f3fe9d$var$load("g9CVe"),
    $6d8289f957f3fe9d$var$load("djHM5"),
    $6d8289f957f3fe9d$var$load("eJQji"),
    $6d8289f957f3fe9d$var$load("6wr18"),
    $6d8289f957f3fe9d$var$load("kjZZD"),
    $6d8289f957f3fe9d$var$load("3JSgG"),
    $6d8289f957f3fe9d$var$load("dRpV3"),
    $6d8289f957f3fe9d$var$load("ffEVr"),
    $6d8289f957f3fe9d$var$load("28arV"),
    $6d8289f957f3fe9d$var$load("jYUNl"),
    $6d8289f957f3fe9d$var$load("foy8I"),
    $6d8289f957f3fe9d$var$load("jY21r"),
    $6d8289f957f3fe9d$var$load("2vAWg"),
    $6d8289f957f3fe9d$var$load("7cABH"),
    $6d8289f957f3fe9d$var$load("9jjvO"),
    $6d8289f957f3fe9d$var$load("i8eeg"),
    $6d8289f957f3fe9d$var$load("iFdoJ"),
    $6d8289f957f3fe9d$var$load("2uVTT"),
    $6d8289f957f3fe9d$var$load("hhss7"),
    $6d8289f957f3fe9d$var$load("Wowvf"),
    $6d8289f957f3fe9d$var$load("4Nzvy"),
    $6d8289f957f3fe9d$var$load("hJpvQ"),
    $6d8289f957f3fe9d$var$load("bIPPg"),
    $6d8289f957f3fe9d$var$load("lnKog"),
    $6d8289f957f3fe9d$var$load("h3ABO"),
    $6d8289f957f3fe9d$var$load("kC80R"),
    $6d8289f957f3fe9d$var$load("7EorR"),
    $6d8289f957f3fe9d$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("tFQTd", function(module, exports) {

let $05932c7ea79ba2ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05932c7ea79ba2ea$var$load("2YffH"),
    $05932c7ea79ba2ea$var$load("lqFMg"),
    $05932c7ea79ba2ea$var$load("duC9l"),
    $05932c7ea79ba2ea$var$load("ci4aH"),
    $05932c7ea79ba2ea$var$load("l1nJ9"),
    $05932c7ea79ba2ea$var$load("eBRUf"),
    $05932c7ea79ba2ea$var$load("9Vh0G"),
    $05932c7ea79ba2ea$var$load("hBIgN"),
    $05932c7ea79ba2ea$var$load("h4Nf7"),
    $05932c7ea79ba2ea$var$load("7f9Fz"),
    $05932c7ea79ba2ea$var$load("8YSo7"),
    $05932c7ea79ba2ea$var$load("eYWAR"),
    $05932c7ea79ba2ea$var$load("8z2kq"),
    $05932c7ea79ba2ea$var$load("g9CVe"),
    $05932c7ea79ba2ea$var$load("djHM5"),
    $05932c7ea79ba2ea$var$load("eJQji"),
    $05932c7ea79ba2ea$var$load("6wr18"),
    $05932c7ea79ba2ea$var$load("kjZZD"),
    $05932c7ea79ba2ea$var$load("3JSgG"),
    $05932c7ea79ba2ea$var$load("dRpV3"),
    $05932c7ea79ba2ea$var$load("ffEVr"),
    $05932c7ea79ba2ea$var$load("28arV"),
    $05932c7ea79ba2ea$var$load("jYUNl"),
    $05932c7ea79ba2ea$var$load("foy8I"),
    $05932c7ea79ba2ea$var$load("jY21r"),
    $05932c7ea79ba2ea$var$load("2vAWg"),
    $05932c7ea79ba2ea$var$load("7cABH"),
    $05932c7ea79ba2ea$var$load("9jjvO"),
    $05932c7ea79ba2ea$var$load("i8eeg"),
    $05932c7ea79ba2ea$var$load("iFdoJ"),
    $05932c7ea79ba2ea$var$load("2uVTT"),
    $05932c7ea79ba2ea$var$load("hhss7"),
    $05932c7ea79ba2ea$var$load("Wowvf"),
    $05932c7ea79ba2ea$var$load("4Nzvy"),
    $05932c7ea79ba2ea$var$load("hJpvQ"),
    $05932c7ea79ba2ea$var$load("bIPPg"),
    $05932c7ea79ba2ea$var$load("lnKog"),
    $05932c7ea79ba2ea$var$load("h3ABO"),
    $05932c7ea79ba2ea$var$load("kC80R"),
    $05932c7ea79ba2ea$var$load("7EorR"),
    $05932c7ea79ba2ea$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("aOasM", function(module, exports) {

let $7de6b0ac5a6d5ca9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7de6b0ac5a6d5ca9$var$load("eYWAR"),
    $7de6b0ac5a6d5ca9$var$load("8z2kq"),
    $7de6b0ac5a6d5ca9$var$load("2YffH"),
    $7de6b0ac5a6d5ca9$var$load("lqFMg"),
    $7de6b0ac5a6d5ca9$var$load("duC9l"),
    $7de6b0ac5a6d5ca9$var$load("ci4aH"),
    $7de6b0ac5a6d5ca9$var$load("hJpvQ"),
    $7de6b0ac5a6d5ca9$var$load("l1nJ9"),
    $7de6b0ac5a6d5ca9$var$load("eBRUf"),
    $7de6b0ac5a6d5ca9$var$load("9Vh0G"),
    $7de6b0ac5a6d5ca9$var$load("hBIgN"),
    $7de6b0ac5a6d5ca9$var$load("h4Nf7"),
    $7de6b0ac5a6d5ca9$var$load("7f9Fz"),
    $7de6b0ac5a6d5ca9$var$load("8YSo7"),
    $7de6b0ac5a6d5ca9$var$load("g9CVe"),
    $7de6b0ac5a6d5ca9$var$load("djHM5"),
    $7de6b0ac5a6d5ca9$var$load("eJQji"),
    $7de6b0ac5a6d5ca9$var$load("6wr18"),
    $7de6b0ac5a6d5ca9$var$load("kjZZD"),
    $7de6b0ac5a6d5ca9$var$load("3JSgG"),
    $7de6b0ac5a6d5ca9$var$load("dRpV3"),
    $7de6b0ac5a6d5ca9$var$load("ffEVr"),
    $7de6b0ac5a6d5ca9$var$load("28arV"),
    $7de6b0ac5a6d5ca9$var$load("jYUNl"),
    $7de6b0ac5a6d5ca9$var$load("foy8I"),
    $7de6b0ac5a6d5ca9$var$load("jY21r"),
    $7de6b0ac5a6d5ca9$var$load("2vAWg"),
    $7de6b0ac5a6d5ca9$var$load("7cABH"),
    $7de6b0ac5a6d5ca9$var$load("9jjvO"),
    $7de6b0ac5a6d5ca9$var$load("i8eeg"),
    $7de6b0ac5a6d5ca9$var$load("iFdoJ"),
    $7de6b0ac5a6d5ca9$var$load("bIPPg"),
    $7de6b0ac5a6d5ca9$var$load("2uVTT"),
    $7de6b0ac5a6d5ca9$var$load("hhss7"),
    $7de6b0ac5a6d5ca9$var$load("Wowvf"),
    $7de6b0ac5a6d5ca9$var$load("4Nzvy"),
    $7de6b0ac5a6d5ca9$var$load("h3ABO"),
    $7de6b0ac5a6d5ca9$var$load("kC80R"),
    $7de6b0ac5a6d5ca9$var$load("7EorR"),
    $7de6b0ac5a6d5ca9$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("a0YkE", function(module, exports) {

let $74a8b42f3d7b69e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74a8b42f3d7b69e5$var$load("eYWAR"),
    $74a8b42f3d7b69e5$var$load("8z2kq"),
    $74a8b42f3d7b69e5$var$load("2YffH"),
    $74a8b42f3d7b69e5$var$load("lqFMg"),
    $74a8b42f3d7b69e5$var$load("duC9l"),
    $74a8b42f3d7b69e5$var$load("ci4aH"),
    $74a8b42f3d7b69e5$var$load("l1nJ9"),
    $74a8b42f3d7b69e5$var$load("eBRUf"),
    $74a8b42f3d7b69e5$var$load("9Vh0G"),
    $74a8b42f3d7b69e5$var$load("hBIgN"),
    $74a8b42f3d7b69e5$var$load("h4Nf7"),
    $74a8b42f3d7b69e5$var$load("7f9Fz"),
    $74a8b42f3d7b69e5$var$load("8YSo7"),
    $74a8b42f3d7b69e5$var$load("g9CVe"),
    $74a8b42f3d7b69e5$var$load("djHM5"),
    $74a8b42f3d7b69e5$var$load("eJQji"),
    $74a8b42f3d7b69e5$var$load("6wr18"),
    $74a8b42f3d7b69e5$var$load("kjZZD"),
    $74a8b42f3d7b69e5$var$load("3JSgG"),
    $74a8b42f3d7b69e5$var$load("dRpV3"),
    $74a8b42f3d7b69e5$var$load("ffEVr"),
    $74a8b42f3d7b69e5$var$load("28arV"),
    $74a8b42f3d7b69e5$var$load("jYUNl"),
    $74a8b42f3d7b69e5$var$load("foy8I"),
    $74a8b42f3d7b69e5$var$load("jY21r"),
    $74a8b42f3d7b69e5$var$load("2vAWg"),
    $74a8b42f3d7b69e5$var$load("7cABH"),
    $74a8b42f3d7b69e5$var$load("9jjvO"),
    $74a8b42f3d7b69e5$var$load("i8eeg"),
    $74a8b42f3d7b69e5$var$load("iFdoJ"),
    $74a8b42f3d7b69e5$var$load("2uVTT"),
    $74a8b42f3d7b69e5$var$load("hhss7"),
    $74a8b42f3d7b69e5$var$load("Wowvf"),
    $74a8b42f3d7b69e5$var$load("4Nzvy"),
    $74a8b42f3d7b69e5$var$load("hJpvQ"),
    $74a8b42f3d7b69e5$var$load("bIPPg"),
    $74a8b42f3d7b69e5$var$load("lnKog"),
    $74a8b42f3d7b69e5$var$load("h3ABO"),
    $74a8b42f3d7b69e5$var$load("kC80R"),
    $74a8b42f3d7b69e5$var$load("7EorR"),
    $74a8b42f3d7b69e5$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("9kPhy", function(module, exports) {

let $6cbdc2e091f73dbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6cbdc2e091f73dbc$var$load("eYWAR"),
    $6cbdc2e091f73dbc$var$load("8z2kq"),
    $6cbdc2e091f73dbc$var$load("2YffH"),
    $6cbdc2e091f73dbc$var$load("lqFMg"),
    $6cbdc2e091f73dbc$var$load("duC9l"),
    $6cbdc2e091f73dbc$var$load("ci4aH"),
    $6cbdc2e091f73dbc$var$load("l1nJ9"),
    $6cbdc2e091f73dbc$var$load("eBRUf"),
    $6cbdc2e091f73dbc$var$load("9Vh0G"),
    $6cbdc2e091f73dbc$var$load("hBIgN"),
    $6cbdc2e091f73dbc$var$load("h4Nf7"),
    $6cbdc2e091f73dbc$var$load("7f9Fz"),
    $6cbdc2e091f73dbc$var$load("8YSo7"),
    $6cbdc2e091f73dbc$var$load("g9CVe"),
    $6cbdc2e091f73dbc$var$load("djHM5"),
    $6cbdc2e091f73dbc$var$load("eJQji"),
    $6cbdc2e091f73dbc$var$load("6wr18"),
    $6cbdc2e091f73dbc$var$load("kjZZD"),
    $6cbdc2e091f73dbc$var$load("3JSgG"),
    $6cbdc2e091f73dbc$var$load("dRpV3"),
    $6cbdc2e091f73dbc$var$load("ffEVr"),
    $6cbdc2e091f73dbc$var$load("28arV"),
    $6cbdc2e091f73dbc$var$load("jYUNl"),
    $6cbdc2e091f73dbc$var$load("foy8I"),
    $6cbdc2e091f73dbc$var$load("jY21r"),
    $6cbdc2e091f73dbc$var$load("2vAWg"),
    $6cbdc2e091f73dbc$var$load("7cABH"),
    $6cbdc2e091f73dbc$var$load("9jjvO"),
    $6cbdc2e091f73dbc$var$load("i8eeg"),
    $6cbdc2e091f73dbc$var$load("iFdoJ"),
    $6cbdc2e091f73dbc$var$load("2uVTT"),
    $6cbdc2e091f73dbc$var$load("hhss7"),
    $6cbdc2e091f73dbc$var$load("Wowvf"),
    $6cbdc2e091f73dbc$var$load("4Nzvy"),
    $6cbdc2e091f73dbc$var$load("hJpvQ"),
    $6cbdc2e091f73dbc$var$load("bIPPg"),
    $6cbdc2e091f73dbc$var$load("lnKog"),
    $6cbdc2e091f73dbc$var$load("h3ABO"),
    $6cbdc2e091f73dbc$var$load("kC80R"),
    $6cbdc2e091f73dbc$var$load("7EorR"),
    $6cbdc2e091f73dbc$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.9dc3e82c.js.map
